import Axios from 'axios'

// Collapse panel
;(() => {
    const burger = document.querySelector('#burger-menu-panel-collapse')
    const panel = document.querySelector('#panel-menu')
    const collapsedClass = 'panel-menu_collapsed'
    const panelNotificationsMenuCollapsedClass = 'panel-notifications_menu-collapsed'
    let locked = false

    const panelNotifications = document.querySelector('#panel-notifications')


    if (!burger || !panel) { return }


    if (panelNotifications) {
        if (panel.classList.contains(collapsedClass)) {
            panelNotifications.classList.add(panelNotificationsMenuCollapsedClass)
        } else {
            panelNotifications.classList.remove(panelNotificationsMenuCollapsedClass)
        }
    }


    const API = panel.dataset.url
    const token = document.querySelector(`meta[name="csrf-token"]`).getAttribute('content')

    if (burger && panel) {
        burger.addEventListener('click', async () => {
            if (locked) { return }

            locked = true

            panel.classList.toggle(collapsedClass)
            if (panelNotifications) {
                panelNotifications.classList.toggle(panelNotificationsMenuCollapsedClass)
            }
            try {
                const result = await Axios.get(API, {
                    headers: {
                        'X-CSRF-TOKEN': token
                    }
                })

                console.log(result)
            } catch (e) {
                locked = false
            }
            
            locked = false

        })
    }
})()
